import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { formatCurrency, formatDate } from '../../utils/formatters';
import TransactionModal from '../Transactions/TransactionModal';

// Agrupa transações marcadas como assinatura (isSubscription:true, ver
// TransactionModal) pelo recurrentGroupId — cada grupo é uma assinatura.
// Lançamento avulso marcado como assinatura (sem série) vira um grupo de 1,
// senão marcar a caixinha ao editar um lançamento antigo não teria efeito.
function groupSubscriptions(transactions) {
  const groups = {};
  transactions.filter(t => t.isSubscription).forEach(t => {
    const key = t.recurrentGroupId || `single-${t.id}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(t);
  });
  return Object.entries(groups).map(([key, items]) => {
    const sorted = [...items].sort((a, b) => a.date.localeCompare(b.date));
    const paid = sorted.filter(t => t.status === 'paid');
    const nextPending = sorted.find(t => t.status === 'pending');
    return {
      groupId: key,
      description: sorted[0].description,
      categoryId: sorted[0].categoryId,
      monthlyValue: sorted[0].value,
      totalPaid: paid.reduce((s, t) => s + t.value, 0),
      paidCount: paid.length,
      nextPending,
      items: sorted,
    };
  }).sort((a, b) => b.monthlyValue - a.monthlyValue);
}

export default function Subscriptions() {
  const { state } = useApp();
  const [expanded, setExpanded] = useState(null);
  const [editingTx, setEditingTx] = useState(null);

  const cats = Object.fromEntries((state.categories || []).map(c => [c.id, c]));
  const subs = groupSubscriptions(state.transactions || []);
  const totalMonthly = subs.reduce((s, g) => s + g.monthlyValue, 0);

  return (
    <div className="page-enter">
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>Assinaturas</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 2 }}>Suas cobranças recorrentes mensais</div>
      </div>

      {subs.length === 0 ? (
        <div className="card">
          <div className="empty-state">
            <i className="fas fa-repeat"></i>
            <div>Nenhuma assinatura marcada ainda</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 6 }}>
              Em Lançamentos, ao criar uma despesa recorrente mensal, marque a caixinha "É uma assinatura" pra ela aparecer aqui.
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="metric-label">Total em assinaturas por mês</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--red)' }}>{formatCurrency(totalMonthly)}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{subs.length} assinatura{subs.length !== 1 ? 's' : ''} ativa{subs.length !== 1 ? 's' : ''}</div>
          </div>

          <div className="card">
            {subs.map((g, i) => {
              const isExpanded = expanded === g.groupId;
              const cat = cats[g.categoryId];
              return (
                <div key={g.groupId} style={{ borderBottom: i < subs.length - 1 ? '1px solid var(--border)' : 'none' }}>
                  <div className="tx-item" style={{ cursor: 'pointer' }} onClick={() => setExpanded(isExpanded ? null : g.groupId)}>
                    <div className="tx-icon">
                      <i className={cat?.icon || 'fas fa-repeat'}></i>
                    </div>
                    <div className="tx-info">
                      <div className="tx-desc">{g.description}</div>
                      <div className="tx-cat">
                        {cat?.name}{g.nextPending && ` · próxima em ${formatDate(g.nextPending.date + 'T12:00:00')}`}
                      </div>
                    </div>
                    <div className="tx-right">
                      <div className="tx-amount">-{formatCurrency(g.monthlyValue)}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)' }}>/mês</div>
                    </div>
                  </div>
                  {isExpanded && (
                    <div style={{ padding: '0 16px 14px 58px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>
                        Já pago: {formatCurrency(g.totalPaid)} ({g.paidCount} cobrança{g.paidCount !== 1 ? 's' : ''})
                      </div>
                      {g.items.map(item => (
                        <div key={item.id} className="tx-item" style={{ padding: '6px 8px', cursor: 'pointer' }} onClick={() => setEditingTx(item)}>
                          <div className="tx-info">
                            <div className="tx-desc" style={{ fontSize: 12 }}>{formatDate(item.date + 'T12:00:00')}</div>
                          </div>
                          <div className="tx-right">
                            <span className={`tag ${item.status === 'paid' ? 'tag-green' : 'tag-amber'}`} style={{ fontSize: 10 }}>
                              {item.status === 'paid' ? 'Pago' : 'Pendente'}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}

      {editingTx && <TransactionModal tx={editingTx} onClose={() => setEditingTx(null)} />}
    </div>
  );
}
